import { render, staticRenderFns } from "./TGO.vue?vue&type=template&id=0a3a3883&scoped=true&"
import script from "./TGO.vue?vue&type=script&lang=js&"
export * from "./TGO.vue?vue&type=script&lang=js&"
import style0 from "./TGO.vue?vue&type=style&index=0&id=0a3a3883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a3883",
  null
  
)

export default component.exports